(function (global, $, Si) {
    "use strict";

    Si.when('Slick').then(testimonialsSlider);

    function testimonialsSlider(Slick) {
        $('.testimonials-slider').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            slide: '.slide',
            prevArrow: '<button type="button" class="slick-prev">' +
            '<i class="icon-angle-left"></i>' +
            '</button>',
            nextArrow: '<button type="button" class="slick-next">' +
            '<i class="icon-angle-right"></i>' +
            '</button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

})(window, jQuery, Si);